import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: "[suppressHorizontalScroll]",
  })
  export class HorizontalScrollSuppressDirective {
    constructor() {
    }
    suppress:boolean = true;

    @HostListener('mouseleave', ["$event"]) onMouseLeave(event : MouseEvent) { this.suppress = true; }
    @HostListener('click', ["$event"]) onClick(event: any) { this.suppress = false; }
    @HostListener("wheel", ["$event"])
    public onScroll(event: WheelEvent) {
      event.cancelBubble = this.suppress;
      if (this.suppress){
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }